// Types for enhanced attendance management
export interface AttendanceRecord {
  id: string
  employeeCode: string
  employeeName?: string 
  user?: {
    id?: string
    employeeCode?: string
    firstName?: string
    lastName?: string
  }
  date: string
  shift: string
  inTime?: string
  outTime?: string
  duration?: string
  lateBy?: string
  earlyBy?: string
  status: string
  punchRecords?: string
  overtime?: string
  isWeekOffDay?: boolean    //Week-Off
}

export interface CreateAttendanceFormData {
  employeeCode: string
  date: string
  inTime: string
  outTime: string
  duration?: string
  lateBy?: string
  earlyBy?: string
  overtime?: string
}

export interface UpdateAttendanceFormData {
  shift?: string
  inTime?: string
  outTime?: string
  status?: string
  duration?: string
  lateBy?: string
  earlyBy?: string
  overtime?: string
}

export interface AttendanceFilters {
  startDate: string
  endDate: string
  userId?: string
  search?: string
  page: number
  limit: number
  sortBy?: string
  sort: 'asc' | 'desc'
  status?: string
}

export interface PayrollSummary {
  employeeCode: string
  totalDays: number
  presentDays: number
  absentDays: number
  lateDays: number
  overtimeHours: number
  totalWorkingHours: number
}

export interface AttendanceResponse {
  statusCode: number
  message: string
  data: {
    attendanceRecords: AttendanceRecord[]
    pagination: {
      currentPage: number
      totalPages: number
      totalRecords: number
      limit: number
    }
  }
}

export interface CRUDModalState {
  isOpen: boolean
  mode: 'create' | 'edit' | 'view' | 'delete'
  record?: AttendanceRecord
}

export const DEFAULT_FILTERS: AttendanceFilters = {
  startDate: '',
  endDate: '',
  userId: '',
  search: '',
  page: 1,
  limit: 10,
  sortBy: 'date',
  sort: 'desc',   
  status: ''  
}

export const DEFAULT_CREATE_FORM: CreateAttendanceFormData = {
  employeeCode: '',
  date: '',
  inTime: '',
  outTime: ''
}

export const ATTENDANCE_STATUSES = [
  { value: 'Present', label: 'Present', color: 'success' },
  { value: 'Absent', label: 'Absent', color: 'danger' },
  { value: 'Early', label: 'Early Leave', color: 'info' },
  { value: 'Late', label: 'Late', color: 'warning' },
  { value: 'Half Day', label: 'Half Day', color: 'info' },
  { value: 'Work From Home', label: 'Work From Home', color: 'primary' },
  { value: 'On Leave', label: 'On Leave', color: 'secondary' }
]

export const SHIFT_OPTIONS = [
  { value: 'General', label: 'General' },
  { value: 'Morning', label: 'Morning' },
  { value: 'Evening', label: 'Evening' },
  { value: 'Night', label: 'Night' },
  { value: 'Weekend', label: 'Weekend' }
]
